
    import Vue from 'vue';
    import { defineComponent } from 'vue';
    import XBreadcrumb from '../../components/Breadcrumb.vue';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import coverNoteService from '@/apps/shared/services/coverNote-service';
    export default defineComponent({
        components: {
            XBreadcrumb,
        },
        data() {
            return {
                modulesPlan: [],
                premioMensual: null,
                coberturas: [],
                Plandata: [],
                selectedPlan: null,
                finallyCalculationResult: [],
                plans: null,
                col: 2,
                plansLength: null,
                notCover: null,
                descriptionPlanNote: null,
                reload: true,
                decimalPremioMensual: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/tecnologia' },
                    { text: 'Cotizador de Equipo Electrónico', path: '/tecnologia/cotizarEquipoElectronico' },
                    { text: 'Valor de tu dispositivo', path: '/tecnologia/valorEquipoElectronico' },
                    { text: 'Elegi un Plan', path: '/tecnologia/elegiPlan' },
                ],
            }
        },
        methods: {
            selectedPlans: function (quotationData) {
                // se le envia el pricingId del plan que se haya elegido
                var pricingId = parseInt(quotationData.pricingId[0])
                sessionStorage.setItem("PlanSelected", JSON.stringify(quotationData));
                checkPricingService.checkStatePricing(pricingId).then(response => {
                    if (response.errorMessage == "Actualizacion correcta") {
                        sessionStorage.setItem("ExitOrContinueModal", "false")

                        window.location.href = '../tecnologia/datosCliente';
                    }
                    else {
                        window.globalThis.dataLayer.push({ 'product': 'tecnologia', 'event': 'errorServidor', 'paso': 'cotizador-tecnologia-plan' });
                    }
                });
            },

            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'electronic-equipment-range-view',
                })
            },

            open: function () {
                this.$refs.modal.open();
            },

            close: function () {
                this.$refs.modal.close();
            },

            dataPlans: function () {
                var PlanData = sessionStorage.getItem("DataQuotation");
                if (PlanData != null) {
                    this.PlanJson = JSON.parse(PlanData);
                    this.plansLength = this.PlanJson[0].plans.length;
                    this.plans = this.PlanJson[0].plans;
                    this.modulesPlan = this.PlanJson[0].modulesPlan

                    for (var i = 0; i < this.plans.length; i++) {
                        var finallyCalculationResultPlan = this.plans[i].finallyCalculationResult.filter(o => o.detalleInt == 1)[0]
                        this.plans[i].finallyCalculationResult.filter(o => o.detalleInt == 1)
                        Object.assign(this.plans[i], this.modulesPlan[i])
                        Object.assign(this.plans[i], finallyCalculationResultPlan)

                        this.plans[i].premioMensual = parseFloat(this.plans[i].premioMensual.toString().replace(/\./g, ''));
                        this.plans[i].premiumWithoutDiscount = parseFloat(this.plans[i].premiumWithoutDiscount.toString().replace(/\./g, ''));
                        this.plans[i].capital = parseFloat(this.plans[i].capital.toString().replace(/\./g, ''));

                        //Formateos con puntos de mil.
                        this.plans[i].premioMensual = this.plans[i].premioMensual.toLocaleString('de-DE', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        });
                        this.plans[i].premiumWithoutDiscount = this.plans[i].premiumWithoutDiscount.toLocaleString('de-DE', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        });
                        this.plans[i].capital = this.plans[i].capital.toLocaleString('de-DE', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        });
                    }
                }
                this.getCoverNote();
            },

            getCoverNote: function () {
                var productId = 1000;
                var securityGroup = '';
                let userName = '';
                let userToken = '';
                let tokenType = "";
                let correlationInformation = "";
                let onDate = new Date().toISOString();
                return new Promise<any>(async (resolve) => {
                    coverNoteService.getCoverNote(onDate, productId, securityGroup, correlationInformation, userName, userToken, tokenType)
                        .then(response => {
                            if (response) {
                                this.coberturas = response.filter(o => o.isChecked == true);
                                this.notCover = response.filter(o => o.isChecked == false);
                                sessionStorage.setItem("cover", JSON.stringify(this.coberturas));
                                sessionStorage.setItem("notCover", JSON.stringify(this.notCover));
                            }
                            else {
                                NF.UI.Page.unblock();
                            }
                        })
                    resolve(true);
                })
            }
        },
        mounted() {
            this.dataPlans();
            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            window.globalThis.dataLayer.push({ 'product': 'tecnologia', 'event': 'cotizador-tecnologia-valor' });
            sessionStorage.removeItem("pressBack");
            var fromTabThree = sessionStorage.getItem("FromTabThree");
            this.descriptionPlanNote = JSON.parse(sessionStorage.getItem("DataGood")).planNote;
            var fromTabFour = sessionStorage.getItem("FromTabFour");
            if (fromTabThree == "true" && fromTabFour == "true") {
                sessionStorage.setItem("FromTabThree", "false");
                location.reload();
            } else {
                sessionStorage.setItem("FromTabThree", "false");
                sessionStorage.setItem("FromTabFour", "true");
            }
        }
    })
